<script setup lang="ts">

import { CarbucksLogo } from "@app/Components/CarbucksLogo";
import type { ICarbucksProfile } from "@domain/Carbucks";
import SpinningCoin from "./SpinningCoin.vue";

interface IProfileHeaderProps
{
    isMarketplace: boolean
}
const props = defineProps<IProfileHeaderProps>();
const model = defineModel<ICarbucksProfile>( { required: true } );
const emit = defineEmits( [ 'dismiss-promotion' ] );

</script>

<template>

    <div class="flex flex-col items-center w-full pt-2 gap-2 3xl:gap-4">
            
        <!-- <CarbucksLogo :size="96" class="top-2" /> -->

        <div class="text-xl lg:text-2xl 3xl:text-4xl text-center px-4 tracking-wider">
            Keeps your car <strong class="uppercase text-primary-500">healthy</strong>
            <br/>
            and your wallet <strong class="uppercase text-primary-500">happy</strong>   
        </div>

        <!-- WERE ON THE MARKETPLACE -->
        <template v-if="isMarketplace">

            <Button variant="text"
                    color="primary"
                    @click="() => emit( 'dismiss-promotion' )">
                Skip for now
            </Button>

            <p class="text-xs 3xl:text-base opacity-60 -mt-2 text-center">
                If you just want to browse the marketplace<br/>and finish setting up your profile later
            </p>

        </template>
        
        <!-- THERE ARE NO LINKED CARDS -->
        <template v-else-if="model.hasLinkedCards == false">
            <p class="text-xs lg:text-base 3xl:text-lg opacity-60 text-center">
                Setup only takes 2 minutes!
            </p>
        </template>
        
    </div>

</template>